import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import axios from 'axios';
import { is_enabled_module } from '@/Composable/usePermission';
import { HandleErrorAxios } from '@/Composable/HandleError';
import pickBy from "lodash/pickBy";

export const useCategoryStore = defineStore('categories', () => {
    const productCategories = ref([]);
    const singleCategory = ref({});
    const loadingProductCategories = ref(false);
    const sortBy = ref('sort');
    const direction = ref('asc');

    const getProductCategories = computed(() => productCategories.value);

    async function fetchProductCategories() {
        if (!is_enabled_module('product')) {
            productCategories.value = [];
            return;
        }
        loadingProductCategories.value = true;
        try {
            await axios.get(route('api.category.index'), {
                params: {
                    withCount: 1,
                    sortBy: sortBy.value,
                    direction: direction.value,
                    limit: 50,
                    withChildern: 1,
                    levelChildren: 1,
                }
            }).then(res => {
                productCategories.value = res.data.data;
            });
            loadingProductCategories.value = false;
        } catch (error) {
            HandleErrorAxios(error);
            console.error(error);
            loadingProductCategories.value = false;
        }

    }

    async function fetchSingleCategory(slug, filters = {}) {
        if (!is_enabled_module('product')) {
            singleCategory.value = {};
            return;
        }

        try {
            let query = pickBy(filters);
            let searchParams = new URLSearchParams(query);
            // console.log(route('api.category.show', slug) + "?" + searchParams);
            await axios.get(route('api.category.show', slug) + "?" + searchParams).then(res => {
                singleCategory.value = res.data.data;
            });
        } catch (error) {
            HandleErrorAxios(error);
            console.error(error);
        }
    }

    function setSingleCategory(category) {
        singleCategory.value = category;
    }
    function getIndex(category) {
        return productCategories.value.findIndex(object => {
            return object.id === category.id;
        });
    }

    function updateCategory(category) {
        const index = getIndex(category);
        if (index !== -1) {
            productCategories.value[index] = category;
        } else {
            productCategories.value.push(category);
        }
    }

    function addToProductCategories(productCategoriesPlus) {
        productCategoriesPlus.map(category => {
            if (!productCategories.value.find(e => e.id == category.id)) {
                productCategories.value.push(category);
            }
            return true;
        });
    }

    function removeFromProductCategories(category) {
        const index = getIndex(category);
        if (index !== -1) {
            productCategories.value.splice(index, 1);
        }
    }

    return {
        productCategories,
        loadingProductCategories,
        getProductCategories,
        fetchProductCategories,
        updateCategory,
        addToProductCategories,
        removeFromProductCategories,
        fetchSingleCategory,
        setSingleCategory,
        singleCategory,
    };
});
